import { render } from "./JobData.vue?vue&type=template&id=4e1269a2&scoped=true"
import script from "./JobData.vue?vue&type=script&lang=js"
export * from "./JobData.vue?vue&type=script&lang=js"

import "./JobData.vue?vue&type=style&index=0&id=4e1269a2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e1269a2"

export default script